import React from "react"
import { IDate, IDateRange, EDayOfWeek } from "../../models"
import TimeActionBar from "../common/TimeActionBar/TimeActionBar"
interface IProps {
  referenceDate: IDate
  handleUpdateDateFilter(dateFilter: IDateRange): void
}

const DateFilterForCalendarView: React.SFC<IProps> = (props: IProps) => {
  if (document.getElementById("TimeActionBar")) {
    document.getElementById("TimeActionBarDate").style.width = "115px"
    document.getElementById("TimeActionBarDateArrow").style.width = "150px"
    document.getElementById("TimeActionBar").style.width = "620px"
  }

  return (
    <div style={{ display: "flex", marginLeft: "auto", order: 2, }}>
      <TimeActionBar
        referenceDate={props.referenceDate}
        handleChangeTimeRange={(StartDate, EndDate) => props.handleUpdateDateFilter({ StartDate, EndDate })}
        startDayOfWeek={EDayOfWeek.Monday}
        timeBarViewType="month"
      />
    </div>
  )
}

export default DateFilterForCalendarView